import React, { type ReactNode, type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';

import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

type Props = {
	show: boolean;
	icon: ReactNode;
	onClick: (event: SyntheticEvent) => void;
};

export const LineCardHiddenButton = (props: Props) => {
	const { show, onClick, icon } = props;
	return (
		<LineCardHiddenButtonContainer
			show={show}
			/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
			data-testid="issue.views.common.line-card-hidden-button.line-card-hidden-button-container"
		>
			<LineCardHiddenButtonWrapper>
				<Button
					// @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactChild | undefined'.
					iconBefore={icon}
					appearance="subtle"
					onClick={onClick}
					spacing="none"
					interactionName="auto-generated.jira-issue-view-common-views.line-card-hidden-button.button"
				/>
			</LineCardHiddenButtonWrapper>
		</LineCardHiddenButtonContainer>
	);
};

// css transform is a "clever" way of hiding the element while still letting it be focusable

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LineCardHiddenButtonContainer = styled.div<{ show: boolean }>({
	height: '100%',
	marginLeft: token('space.025'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	transform: ({ show }) => `scale(${show ? 1 : 0})`,
	marginRight: token('space.negative.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LineCardHiddenButtonWrapper = styled.div({
	display: 'inline-block',
	verticalAlign: 'middle',
	marginTop: token('space.100'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 4}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 3}px`,
	marginLeft: token('space.100'),
});
